import React, { Component, type ComponentType, type MouseEvent } from 'react';
import DropDown from '../../dropDown/dropDown';
import type {
  WithDropDownOnActionDropDownProps,
  WithDropDownOnActionProps,
} from './withDropDownTypes';

export interface ComponentWithDropDownOnClickProps {
  onClick: (event: MouseEvent) => void;
}

const withDropDownOnClick = <P extends WithDropDownOnActionProps>(
  WrappedComponent: ComponentType<P & ComponentWithDropDownOnClickProps>,
) => {
  class WithDropDownOnClick extends Component<
    WithDropDownOnActionProps & WithDropDownOnActionDropDownProps
  > {
    handleClick = (event: MouseEvent) => {
      const { handlerKey, dropPanelKey } = this.props;

      this.props.openDropPanel(handlerKey || dropPanelKey, 0);
      this.props.onClick?.(event);
    };

    render() {
      const { dropPanelKey, openedDropPanel } = this.props;
      const isOpen = dropPanelKey === openedDropPanel;

      const wrappedComponent = React.createElement(
        WrappedComponent,
        Object.assign({}, this.props as P, {
          onClick: this.handleClick,
        }),
      );

      return (
        <DropDown
          isOpen={isOpen}
          delayedFadeOut={false}
          onPanelOuterClick={this.props.closeDropPanel}
          panelContent={this.props.dropPanelContent}
          panelTopMargin={this.props.panelTopMargin}
          panelClassName={this.props.panelClassName}
        >
          {wrappedComponent}
        </DropDown>
      );
    }
  }

  return WithDropDownOnClick;
};

export default withDropDownOnClick;
